import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { SortingIcon } from '@atlaskit/editor-common/table';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export var SortingIconWrapper = function SortingIconWrapper(props) {
  var _useSharedPluginState = useSharedPluginState(props.api, ['editorViewMode'], {
      disabled: editorExperiment('platform_editor_usesharedpluginstateselector', true)
    }),
    editorViewModeState = _useSharedPluginState.editorViewModeState;

  // mode
  var modeSelector = useSharedPluginStateSelector(props.api, 'editorViewMode.mode', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var mode = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? modeSelector : editorViewModeState === null || editorViewModeState === void 0 ? void 0 : editorViewModeState.mode;
  if (mode === 'edit') {
    return null;
  }
  // Ignored via go/ees005
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React.createElement(SortingIcon, props);
};